module.exports = __webpack_public_path__ + "img/bus-gray-sentosa.6f96d34a.svg";